import { CardMediaSlot } from "@/components/landing/CardMediaSlot";

export function PartnershipModels({ content, media = [] }) {
  return (
    <section className="section partnership-models-section" data-slide="09" data-testid="partnership-models-section">
      <div className="section-heading wide">
        <p className="overline" data-testid="partnership-models-overline">{content.overline}</p>
        <h2 data-testid="partnership-models-title">{content.title}</h2>
        <p data-testid="partnership-models-description">{content.description}</p>
      </div>

      <div className="model-grid" data-testid="partnership-model-grid">
        {content.models.map((model, index) => (
          <article className="model-card" key={model.title} data-testid={`partnership-model-card-${index + 1}`}>
            <CardMediaSlot image={media[index]?.image} label={model.title} testId={`partnership-model-media-${index + 1}`} className="compact-media" />
            <span data-testid={`partnership-model-number-${index + 1}`}>{String(index + 1).padStart(2, "0")}</span>
            <h3 data-testid={`partnership-model-title-${index + 1}`}>{model.title}</h3>
            <p data-testid={`partnership-model-text-${index + 1}`}>{model.text}</p>
          </article>
        ))}
      </div>
    </section>
  );
}